import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const SavingTable = ({ showTable, historyData= null,
  shouldGenerateReport,
  setShouldGenerateReport,calcDone }) => {
  const { textData} = useLocale();
  const [reportData, setReportData] = useState([]);
  const {
    savingGoalAmount,
    existingInvestment,
    expectedInflation,
    expectedReturn,
    timePeriod,
    monthlyInvestment,
    futureValueOfGoal,
    futureValueOfExistingInvestment,
  } = useSelector((state) => state.savingsCalculator);
  useEffect(() => {
    if(historyData){
        generateHistoryReport();
    }
   
  }, [
    showTable,
    savingGoalAmount,
    existingInvestment,
    expectedInflation,
    expectedReturn,
    timePeriod,
    monthlyInvestment,
    futureValueOfGoal,
    futureValueOfExistingInvestment,
    historyData
  ]);

    useEffect(() => {
      if (shouldGenerateReport) {
        generateReportData();
        setShouldGenerateReport(false);
      }else if (!calcDone) {
    setReportData([]); 
  }
  generateHistoryReport();
}, [shouldGenerateReport, calcDone, historyData]);


const generateHistoryReport = () =>{
    if(!Array.isArray(historyData) || historyData.length === 0) {
        return;
    }
    const savingData = historyData[0];
    const yearlyData = [];
    const initialGoal = Number(savingData.savingGoalAmount);
    const initialInvestment = Number(savingData.existingInvestment);
    const inflationRate = Number(savingData.expectedInflation) / 100;
    const returnRate = Number(savingData.expectedReturn) / 100;
    const years = Number(savingData.timePeriod);
    const monthlyPayment = Number(savingData.monthlyInvestment);

    let currentInvestmentValue = initialInvestment;

    for (let year = 1; year <= years; year++) {
      const inflatedGoal = initialGoal * Math.pow(1 + inflationRate, year);

      const existingInvestmentValue =
        initialInvestment * Math.pow(1 + returnRate, year);
      const monthlyRate = returnRate / 12;
      const totalMonths = year * 12;
      const periodicContributions =
        monthlyPayment *
        ((Math.pow(1 + monthlyRate, totalMonths) - 1) / monthlyRate);

      const cumulativeSavings = existingInvestmentValue + periodicContributions;

      const remainingAmount = Math.max(0, inflatedGoal - cumulativeSavings);

      yearlyData.push({
        year,
        monthlyPayment,
        cumulativeSavings,
        goalInflaction: inflatedGoal,
        remainingAmount,
      });
    }

    setReportData(yearlyData);
}

  const generateReportData = () => {
    const yearlyData = [];

    const initialGoal = Number(savingGoalAmount);
    const initialInvestment = Number(existingInvestment);
    const inflationRate = Number(expectedInflation) / 100;
    const returnRate = Number(expectedReturn) / 100;
    const years = Number(timePeriod);
    const monthlyPayment = Number(monthlyInvestment);

    let currentInvestmentValue = initialInvestment;

    for (let year = 1; year <= years; year++) {
      const inflatedGoal = initialGoal * Math.pow(1 + inflationRate, year);

      const existingInvestmentValue =
        initialInvestment * Math.pow(1 + returnRate, year);
      const monthlyRate = returnRate / 12;
      const totalMonths = year * 12;
      const periodicContributions =
        monthlyPayment *
        ((Math.pow(1 + monthlyRate, totalMonths) - 1) / monthlyRate);

      const cumulativeSavings = existingInvestmentValue + periodicContributions;

      const remainingAmount = Math.max(0, inflatedGoal - cumulativeSavings);

      yearlyData.push({
        year,
        monthlyPayment,
        cumulativeSavings,
        goalInflaction: inflatedGoal,
        remainingAmount,
      });
    }

    setReportData(yearlyData);
  };

  const columns = [
    { key: "year", label: textData.tableLabels.year, format: (value) => value },
    {
      key: "monthlyPayment",
      label: `${textData.tableLabels.monthlyPayment} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "cumulativeSavings",
      label: `${textData.tableLabels.cumulativeSavings} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "goalInflaction",
      label: `${textData.tableLabels.goalInflaction} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "remainingAmount",
      label: `${textData.tableLabels.remainingAmount} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
  ];
  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.savingCalc} ${textData.report}`}
      data={reportData}
      columns={columns}
      analyticsEventName="download_pl_report"
      reportTitle={textData.reportTitle.savingReport}
      fileName="saving_detail"
    />
  );
};

export default SavingTable;
